import { Languages } from '../LanguageContext';
import { getTranslation } from '../consts/translations';

export type ValidationErrorCode =
  | 'must_answer'
  | 'date_invalid'
  | 'select_min_options'
  | 'number_between'
  | 'number_min'
  | 'number_max'
  | 'invalid_number'
  | 'invalid_input'
  | 'date_from_today'
  | 'date_no_future'
  | 'date_before_dep'
  | 'date_after_or_equal_dep'
  | 'date_after_dep'
  | 'number_before_dep'
  | 'number_after_or_equal_dep'
  | 'number_after_dep'
  | 'error_question'
  | 'general_submit_error'
  | 'volunteer_name_mismatch';

const VALIDATION_KEY_BY_CODE: Record<ValidationErrorCode, keyof ReturnType<typeof getTranslation>> =
  {
    must_answer: 'validation_must_answer',
    date_invalid: 'validation_date_invalid',
    select_min_options: 'validation_select_min_options',
    number_between: 'validation_number_between',
    number_min: 'validation_number_min',
    number_max: 'validation_number_max',
    invalid_number: 'validation_invalid_number',
    invalid_input: 'validation_invalid_input',
    date_from_today: 'validation_date_from_today',
    date_no_future: 'validation_date_no_future',
    date_before_dep: 'validation_date_before_dep',
    date_after_or_equal_dep: 'validation_date_after_or_equal_dep',
    date_after_dep: 'validation_date_after_dep',
    number_before_dep: 'validation_number_before_dep',
    number_after_or_equal_dep: 'validation_number_after_or_equal_dep',
    number_after_dep: 'validation_number_after_dep',
    error_question: 'validation_error_question',
    general_submit_error: 'validation_general_submit_error',
    volunteer_name_mismatch: 'validation_volunteer_name_mismatch',
  };

export function formatValidationMessage(
  template: string,
  params: Record<string, string | number> = {},
): string {
  return Object.entries(params).reduce(
    (message, [key, value]) => message.replaceAll(`%${key}%`, String(value)),
    template,
  );
}

export function getValidationMessage(
  language: Languages,
  code: ValidationErrorCode,
  params?: Record<string, string | number>,
): string {
  const translation = getTranslation(language);
  const key = VALIDATION_KEY_BY_CODE[code];
  const template = translation[key] ?? getTranslation(Languages.HEBREW)[key];
  return formatValidationMessage(template, params);
}
